import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { format } from 'date-fns';
import { observer } from 'mobx-react';
import { NewLender } from '../../types/companyProfileTypes';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 1000,
    margin: 'auto',
    marginBottom: theme.spacing(6),
    minHeight: 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(6),
    textAlign: 'center',
    backgroundColor: '#fff',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(2),
    boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
    position: 'relative',
  },
  title: {
    fontWeight: 700,
    fontSize: '1.4rem',
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  subtitle: {
    fontSize: '1.1rem',
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  party: {
    fontWeight: 500,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  role: {
    fontStyle: 'italic',
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  date: {
    marginTop: theme.spacing(5),
    fontSize: '1rem',
    color: theme.palette.text.primary,
  },
}));




interface Props {
  lender: NewLender
}

export const LoanAgreementCoverPage = observer(({ lender }: Props) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Typography className={classes.title}>
        MASTER LOAN PURCHASE AND SALE AGREEMENT
      </Typography>

      <Typography className={classes.subtitle}>by and between</Typography>

      <Typography className={classes.party}>
        {`${lender.company.name},`}
      </Typography>
      <Typography className={classes.role}>as Seller</Typography>

      <Typography className={classes.subtitle}>AND</Typography>

      <Typography className={classes.party}>LOAN FUNDER LLC,</Typography>
      <Typography className={classes.role}>as Buyer</Typography>

      <Typography className={classes.date}>
        Dated as of <strong>{format(new Date(), 'MMMM d, yyyy')}</strong>
      </Typography>
    </Box>
  );
});
